import React from 'react';
const Trainers = () => <div className="service-page"><h1>Trainers</h1><p>Certified trainers for personal and group fitness.</p></div>;
export default Trainers;
